"use client";

import dynamic from "next/dynamic";
import { DynamicLoading } from "../DynamicLoading";
import type { PdfViewerProps } from "./PdfViewerInner";

const PdfViewerInner = dynamic(
  () => import("./PdfViewerInner").then((mod) => mod.PdfViewerInner),
  {
    ssr: false,
    loading: () => <DynamicLoading isLoading={true} />,
  },
);

export type { PdfViewerProps } from "./PdfViewerInner";

export function PdfViewer(props: PdfViewerProps) {
  return <PdfViewerInner {...props} />;
}
